import { orchestrator } from 'satcheljs';
import {
    getMailboxJunkEmailConfiguration,
    saveMailboxJunkEmailConfiguration,
} from 'owa-junkmail-configuration';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { blockSender, removeSenderFromSubscriptionStore } from '../actions/internalActions';
import {
    blockSendersDialogTitle,
    blockSendersDialogSubtext,
} from '../BrandSubscriptionsOption.locstring.json';
import loc, { format } from 'owa-localize';

export default orchestrator(blockSender, async actionMessage => {
    const confirmResponse = await confirm(
        format(loc(blockSendersDialogTitle), actionMessage.displayName),
        format(loc(blockSendersDialogSubtext), actionMessage.emailAddress)
    );
    if (confirmResponse !== DialogResponse.ok) {
        return;
    }

    removeSenderFromSubscriptionStore(actionMessage.emailAddress, actionMessage.isUnsubscribed);

    const currentConfiguration = await getMailboxJunkEmailConfiguration();
    currentConfiguration.BlockedSendersAndDomains = currentConfiguration.BlockedSendersAndDomains.concat(
        actionMessage.emailAddress
    );
    saveMailboxJunkEmailConfiguration(currentConfiguration);
});
